import Swiper from 'swiper/bundle';
import Choices from 'choices.js/public/assets/scripts/choices.js';
import Core from './core';
class Sections {
    constructor() {
        debugger;
        window.Choices = Choices;

        this.file_inp = document.querySelector('.form__input__inp--file') ? document.querySelectorAll('.form__input__inp--file') : null;
        this.select = document.querySelector('.select_c') ? document.querySelectorAll('.select_c') : null;
        this.home_slider = document.querySelector('.home-slider') ? document.querySelectorAll('.home-slider') : null;
        this.accordions = document.querySelector('.accordions') ? document.querySelectorAll('.accordions') : null;
        this.testimonial_slider = document.querySelector('.testimonial-slider') ? document.querySelectorAll('.testimonial-slider') : null;
        this.ts_slider_vertical = document.querySelector('.ts_slider-vertical') ? document.querySelectorAll('.ts_slider-vertical') : null;
        this.image_gallery_slider = document.querySelector('.image-gallery-slider') ? document.querySelectorAll('.image-gallery-slider') : null;
        this.switch_list_speakers = document.querySelector('.switch_list') ? document.querySelectorAll('.switch_list') : null;
        this.star_counters = document.querySelector('.star-counters') ? document.querySelectorAll('.star-counters') : null;
        this.contnet_slider = document.querySelector('.contnet-slider') ? document.querySelectorAll('.contnet-slider') : null;
        this.logo_slider = document.querySelector('.logo-slider') ? document.querySelectorAll('.logo-slider') : null;
        this.page_subnav = document.querySelector('.page-subnav') ? document.querySelectorAll('.page-subnav') : null;
        this.event_sessions = document.querySelector('.event-sessions') ? document.querySelectorAll('.event-sessions') : null;



        !this.event_sessions || this.event_sessions.forEach(item => this.sEvent(item));
        !this.page_subnav || this.page_subnav.forEach(item => this.sSubnav(item));
        !this.logo_slider || this.logo_slider.forEach(item => this.sLogo(item));
        !this.contnet_slider || this.contnet_slider.forEach(item => this.sliderS(item));
        !this.star_counters || this.star_counters.forEach(item => this.sCounters(item));
        !this.image_gallery_slider || this.image_gallery_slider.forEach(item => this.sSlider(item));
        !this.ts_slider_vertical || this.ts_slider_vertical.forEach(item => this.sSlider(item));
        !this.testimonial_slider || this.testimonial_slider.forEach(item => this.sSlider(item));
        !this.accordions || this.accordions.forEach(item => this.sAccordion(item));
        !this.home_slider || this.home_slider.forEach(item => this.sSlider(item));
        !this.file_inp || this.file_inp.forEach(item => this.inpFile(item));


        !this.switch_list_speakers || this.switch_list_speakers.forEach(el => {
            if (document.body.clientWidth <= 776) this.switchList(el.querySelector('.switch_list__grid--mobile'));
            else this.switchList(el.querySelector('.switch_list__grid:not(.switch_list__grid--mobile)'));
        });

        !this.select || this.select.forEach(item => {
            const isAutoSortDisabled = item.dataset.autosortchoices?.toLowerCase() === "false";

            const myChoices = new Choices(item, {
                searchEnabled: false,
                itemSelectText: '',
                shouldSort: !isAutoSortDisabled
            });

            // Adds JQuery Validate onto the custom choices select to allow error messages to show/hide
            myChoices.passedElement.element.addEventListener('change', function () {
                $(item).valid();
            });
        });
    }

    sEvent(el) {
        if (el.querySelector('.show-hidden')) {
            el.querySelector('.show-hidden').addEventListener('click', e => {
                e.preventDefault();
                if (el.querySelector('.show-hidden').innerText === 'See more') {
                    el.querySelector('.show-hidden').innerText = 'Show less';
                } else el.querySelector('.show-hidden').innerText = 'See more';
                this.slideToggle(el.querySelector('.hidden'), 300);

            })

        }
    }

    sSubnav(el) {
        el.querySelector('.page-subnav__mobile').addEventListener('click', e => {
            el.querySelector('.page-subnav__mobile').classList.toggle('active');
            this.slideToggle(el.querySelector('.nav'), 500);
        });
    }

    sLogo(el) {
        const swiperContainer = el.querySelector('.swiper');
        const swiperWrapper = swiperContainer.querySelector('.swiper-wrapper');
        const slideCount = swiperWrapper.childElementCount;
        const maxSlides = Math.min(slideCount, 7);

        // Check if we have enough slides for looping
        // Swiper needs at least double the slidesPerView count for proper looping
        const minSlidesForLoop = Math.max(maxSlides * 2, 10); // Minimum 10 slides for smooth continuous loop
        
        // If we don't have enough slides, duplicate them
        if (slideCount < minSlidesForLoop) {
            const slides = Array.from(swiperWrapper.children);  
            const duplicationsNeeded = Math.ceil(minSlidesForLoop / slideCount);
            
            for (let i = 1; i < duplicationsNeeded; i++) {
                slides.forEach(slide => {
                    const clone = slide.cloneNode(true);
                    swiperWrapper.appendChild(clone);
                });
            }
        }

        const swiper = new Swiper(swiperContainer, {
            slidesPerView: 2,
            spaceBetween: 30,
            loop: true,
            speed: 7000, // Reduced speed for smoother animation
            freeMode: false,
            autoplay: {
                delay: 1, // Small delay to ensure smooth transition
                disableOnInteraction: false,
                reverseDirection: false
            },
            allowTouchMove: false,
            loopAdditionalSlides: 2, // Add extra slides for smooth looping
            breakpoints: {
                1200: {
                    slidesPerView: maxSlides,
                },
                991: {
                    slidesPerView: 5,
                },
                600: {
                    slidesPerView: 4,
                },
                400: {
                    slidesPerView: 2,
                }
            }
        });
    }

    sliderS(el) {
        const swiper = new Swiper(el.querySelector('.swiper-container'), {
            slidesPerView: 1.1,
            centeredSlides: false,

            loop: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            breakpoints: {
                991: {
                    slidesPerView: 2,
                    centeredSlides: true,
                }
            }
        });
    }

    sCounters(el) {
        const counters = el.querySelectorAll("span[data-number]");

        counters.forEach((counter) => {
            const target = parseFloat(counter.getAttribute("data-number").replace(/,/g, ""));
            let current = 0;
            const increment = target / 100;
            const duration = 2000;
            const interval = duration / 100;

            const updateCounter = () => {
                current += increment;

                if (current >= target) {
                    counter.innerText = target.toLocaleString("en-US");
                } else {
                    counter.innerText = Math.round(current).toLocaleString("en-US");
                    requestAnimationFrame(updateCounter);
                }
            };

            updateCounter();
        });
    }

    switchList(el) {
        el.querySelectorAll('.box').forEach(item => {
            item.querySelectorAll('.circle span').forEach(span => span.addEventListener('click', e => {
                if (item.classList.contains('active')) {
                    item.classList.remove('active');
                    this.slideUp(el.querySelector(`.info_box[data-item='${item.dataset.item}']`), 300);
                } else {
                    el.querySelectorAll('.box').forEach(it => it.classList.remove('active'));
                    el.querySelectorAll('.info_box').forEach(it => this.slideUp(it, 100));

                    item.classList.add('active');
                    setTimeout(() => {
                        this.slideDown(el.querySelector(`.info_box[data-item='${item.dataset.item}']`), 300);

                    }, 100);

                }
            }));
        })
    }

    sAccordion(item) {
        const accordion = item;
        const accordionItems = accordion.querySelectorAll('.item');

        accordionItems.forEach(el => {
            el.querySelector('.item__head').addEventListener('click', e => {
                const currentHead = el.querySelector('.item__head');
                const currentContent = el.querySelector('.item__content');
                const isCurrentlyActive = currentHead.classList.contains('active');

                // Close all other accordion items
                accordionItems.forEach(otherEl => {
                    if (otherEl !== el) {
                        const otherHead = otherEl.querySelector('.item__head');
                        const otherContent = otherEl.querySelector('.item__content');

                        if (otherHead.classList.contains('active')) {
                            otherHead.classList.remove('active');
                            this.slideUp(otherContent, 500);
                        }
                    }
                });

                // Toggle the current item
                if (isCurrentlyActive) {
                    currentHead.classList.remove('active');
                    this.slideUp(currentContent, 500);
                } else {
                    currentHead.classList.add('active');
                    this.slideDown(currentContent, 500);
                }
            });
        });
    }

    inpFile(el) {
        const fileUpload = el.querySelector('.file-inp');
        const fileText = el.querySelector('.file-text');

        fileUpload.addEventListener("change", () => {
            const files = fileUpload.files;
            const fileCount = files.length;
            if (fileCount > 0) {
                for (let i = 0; i < fileCount; i++) {
                    const file = files[i];
                    const fileName = file.name;

                    const span = document.createElement('span');
                    span.innerText = fileName;
                    fileText.appendChild(span);

                }
                fileText.classList.add('active');
            }
        });
    }

    sSlider(el) {
        new Swiper(el.querySelector(".mySwiper"), {
            autoHeight: true,
            navigation: {
                nextEl: el.querySelector(".swiper-button-next"),
                prevEl: el.querySelector(".swiper-button-prev"),
            },
        });
    }
    slideUp(target, duration = 500) {
        target.style.transitionProperty = 'height, margin, padding';
        target.style.transitionDuration = duration + 'ms';
        target.style.boxSizing = 'border-box';
        target.style.height = target.offsetHeight + 'px';
        target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        window.setTimeout(() => {
            target.style.display = 'none';
            target.style.removeProperty('height');
            target.style.removeProperty('padding-top');
            target.style.removeProperty('padding-bottom');
            target.style.removeProperty('margin-top');
            target.style.removeProperty('margin-bottom');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
            //alert("!");
        }, duration);
    }

    slideDown(target, duration = 500) {
        target.style.removeProperty('display');
        let display = window.getComputedStyle(target).display;

        if (display === 'none')
            display = 'block';

        target.style.display = display;
        let height = target.offsetHeight;
        target.style.overflow = 'hidden';
        target.style.height = 0;
        target.style.paddingTop = 0;
        target.style.paddingBottom = 0;
        target.style.marginTop = 0;
        target.style.marginBottom = 0;
        target.offsetHeight;
        target.style.boxSizing = 'border-box';
        target.style.transitionProperty = "height, margin, padding";
        target.style.transitionDuration = duration + 'ms';
        target.style.height = height + 'px';
        target.style.removeProperty('padding-top');
        target.style.removeProperty('padding-bottom');
        target.style.removeProperty('margin-top');
        target.style.removeProperty('margin-bottom');
        window.setTimeout(() => {
            target.style.removeProperty('height');
            target.style.removeProperty('overflow');
            target.style.removeProperty('transition-duration');
            target.style.removeProperty('transition-property');
        }, duration);
    }

    slideToggle(target, duration = 500) {
        if (window.getComputedStyle(target).display === 'none') {
            return this.slideDown(target, duration);
        } else {
            return this.slideUp(target, duration);
        }
    }

}

export default Sections;